// VideoInterviewStyles.js - Node 22 Version (Complete)
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((_theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    padding: "0px 5px",
  },
  popover: {
    pointerEvents: "none",
  },
  videodiv: {
    width: "100%",
    height: "auto",
    overflow: "hidden",
  },
  button: {
    color: "#ffffff !important",
    backgroundColor: "#D32F2F !important",
    "&:disabled": {
      backgroundColor: "#A9A9A9 !important",
      color: "#ffffff !important",
      cursor: "not-allowed !important",
    },
    "&:hover": {
      color: "#ffffff !important",
      backgroundColor: "#FF5733 !important",
    },
  },
  container: {
    marginTop: "3px",
    width: "100%",
    maxWidth: "100vw",
    height: "60%",
  },
  video: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "15px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    "@media (min-width: 600px)": {
      width: "70%",
    },
    "@media (min-width: 960px)": {
      width: "60%",
    },
    "@media (min-width: 1280px)": {
      width: "30%",
    },
  },
  dialog: {
    "& .MuiDialog-paper": {
      backgroundColor: "#f0f0f0",
      padding: "16px",
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: "#ccc",
    },
    "& .MuiDialogContent-root": {
      padding: "16px",
    },
    "& .MuiDialogActions-root": {
      justifyContent: "space-between",
    },
  },
  timerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f2e6f9",
    borderRadius: "50%",
    width: "150px",
    height: "150px",
    boxShadow: "0 4px 15px rgba(111, 41, 129, 0.5)",
    marginBottom: "20px",
  },
  timer: {
    fontSize: "50px",
    fontWeight: "bold",
    color: "#6f2981",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
  },
}));
